import { render, staticRenderFns } from "./ReportVulnerabilityStats.vue?vue&type=template&id=512d7f2d"
import script from "./ReportVulnerabilityStats.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportVulnerabilityStats.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports